import { render } from "./BookingTrash.vue?vue&type=template&id=3d0c3893&scoped=true"
import script from "./BookingTrash.vue?vue&type=script&lang=js"
export * from "./BookingTrash.vue?vue&type=script&lang=js"

import "./BookingTrash.vue?vue&type=style&index=0&id=3d0c3893&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0c3893"]])

export default __exports__